// ============================================
// Path: /frontend/src/api/jointVentures.api.js
// Purpose: Joint ventures API endpoints
// ============================================

import apiClient from './client.js';

export const jointVenturesAPI = {
  // Get all joint ventures (admin only)
  getAllJointVentures: async () => {
    console.log('[jointVenturesAPI] Fetching all joint ventures (admin)');
    try {
      const response = await apiClient.get('/joint-ventures');
      console.log('[jointVenturesAPI] Fetched', response.data.jointVentures?.length || 0, 'JVs');
      return response.data;
    } catch (error) {
      console.error('[jointVenturesAPI] Error fetching joint ventures:', error);
      throw error;
    }
  },

  // Register for joint venture
  registerJointVenture: async (ventureData) => {
    console.log('[jointVenturesAPI] Registering joint venture:', ventureData.role);
    try {
      const response = await apiClient.post('/joint-ventures', ventureData);
      console.log('[jointVenturesAPI] Joint venture registered successfully');
      return response.data;
    } catch (error) {
      console.error('[jointVenturesAPI] Error registering joint venture:', error);
      throw error;
    }
  },

  // Initiate JV payment
  initiateJVPayment: async (paymentData) => {
    console.log('[jointVenturesAPI] Initiating JV payment:', paymentData.packageId);
    try {
      const response = await apiClient.post('/joint-ventures/payment/initiate', paymentData);
      console.log('[jointVenturesAPI] Payment initiated:', response.data);
      return response.data;
    } catch (error) {
      console.error('[jointVenturesAPI] Error initiating payment:', error);
      throw error;
    }
  },

  // Update submission status (admin only)
  updateStatus: async (id, data) => {
    console.log('[jointVenturesAPI] Updating status:', id);
    try {
      const response = await apiClient.patch(`/joint-ventures/${id}/status`, data);
      console.log('[jointVenturesAPI] Status updated');
      return response.data;
    } catch (error) {
      console.error('[jointVenturesAPI] Error updating status:', error);
      throw error;
    }
  },

  // Run matching algorithm (admin only)
  runMatching: async () => {
    console.log('[jointVenturesAPI] Running matching algorithm');
    try {
      const response = await apiClient.post('/joint-ventures/match');
      console.log('[jointVenturesAPI] Matching complete');
      return response.data;
    } catch (error) {
      console.error('[jointVenturesAPI] Error running matching:', error);
      throw error;
    }
  },
  // Get my submission
  // Get my submissions (with optional role filter and pagination)
  
    getMySubmission: async (role = null, page = 1, limit = 10) => {
      const params = new URLSearchParams({ page: page.toString(), limit: limit.toString() });
      if (role) params.append('role', role);
      
      console.log('[jointVenturesAPI] Fetching my submissions:', { role, page, limit });
      try {
        const response = await apiClient.get(`/joint-ventures/my-submission?${params}`);
        console.log('[jointVenturesAPI] Submissions fetched:', response.data.submissions?.length || 0);
        return response.data;
      } catch (error) {
        console.error('[jointVenturesAPI] Error fetching submissions:', error);
        throw error;
      }
    },

  // Delete joint venture (admin only)
  deleteJointVenture: async (id) => {
    console.log('[jointVenturesAPI] Deleting joint venture:', id);
    try {
      const response = await apiClient.delete(`/joint-ventures/${id}`);
      console.log('[jointVenturesAPI] Joint venture deleted successfully');
      return response.data;
    } catch (error) {
      console.error('[jointVenturesAPI] Error deleting joint venture:', error);
      throw error;
    }
  },

createJVListingDirect: async (submissionData) => {
  console.log('[jointVenturesAPI] Creating JV listing directly (no payment)');
  try {
    const response = await apiClient.post('/joint-ventures/create-direct', submissionData);
    console.log('[jointVenturesAPI] Listing created:', response.data);
    return response.data;
  } catch (error) {
    console.error('[jointVenturesAPI] Error creating JV listing:', error);
    throw error;
  }
},

};

